import React, { Component } from 'react';
import { __ } from 'i18n-for-browser';

import apiCall from "../apiCall";
import GoBackButton from "../elements/GoBackButton";
import GameMaterials from '../elements/GameMaterials';
import { connect } from 'react-redux';

class SchoolPortalTest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gameMaterials: [],
      gameMaterialsFetched: false,
      fetchingGameMaterials: false,
    };
  }
  componentDidMount() { this.fetchGeneralMaterials() }
  componentDidUpdate() { this.fetchGeneralMaterials() }

  fetchGeneralMaterials = () => {
    if (this.props.project && this.props.project.id && !this.state.gameMaterialsFetched && !this.state.fetchingGameMaterials) {
      this.setState({ fetchingGameMaterials: true });
      const { project } = this.props;
      apiCall(`/generalMaterial/${project.DefaultLanguageId}/${project.DefaultDifficultyId}/software_testen`)
        .then((gameMaterials) => {
          this.setState({ gameMaterials });
        }).finally(() => {
          this.setState({ gameMaterialsFetched: true, fetchingGameMaterials: false, });
        });
    }
  };

  render() {
    return (
      <div className="portal-home portal-school-tests darkBckg">
        <div className="desktop-content-center">
          <div className='content-section title-section-white'>
            <h1 className='content-container-bigTitle'>{__('sim_test_systeembeheer')}</h1>
            <p>{__('sim_software_testen')}</p>

            <GoBackButton history={this.props.history}/>
          </div>
          <div className='content-section'>
            <h2 className="content-container-title">{__('sim_software')}</h2>
            <GameMaterials items={this.state.gameMaterials} />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(({ project}) => ({ project }))(SchoolPortalTest);



// WEBPACK FOOTER //
// ./src/components/desktop/SchoolPortalTest.js